// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Create hold'"></sub-header>

    <!-- Product information -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product number:</span>
        <span class="value">{{\$ctrl.account.productNumber}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Product status:</span>
        <span class="value">{{\$ctrl.account.status | prettyEnum}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value">{{\$ctrl.account.balance | nxCurrency}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Holds balance:</span>
        <span class="value">{{\$ctrl.account.holdsBalance | nxCurrency}}</span>
      </div>
    </div>

    <br/>

    <form name="\$ctrl.transactionForm">

      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Amount</td>
          <td>
            <cash ng-model="\$ctrl.hold.amount"
              ng-required="true"
              max="\$ctrl.account.balance"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Auto release</td>
          <td>
            <select
              required
              ng-model="\$ctrl.hold.autoRelease"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.hold.autoRelease">
          <td></td>
          <td>Auto release on</td>
          <td>
            <date output-format="date"
              validate-date="gt:posting-date"
              default-date-offset="1"
              ng-required="true"
              ng-model="\$ctrl.hold.autoReleaseOn"></date>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Remarks</td>
          <td>
            <input
              required
              type="text"
              minlength="1"
              maxlength="128"
              ng-model="\$ctrl.hold.creationRemarks"/>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          class="btn btn-success"
          command-access="CreateManualHold"
          ng-click="\$ctrl.create()"
          ng-disabled="\$ctrl.transactionForm.\$invalid">
          Create
        </button>
      </div>

    </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/create-hold/create-account-hold.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;